import EditIcon from "@mui/icons-material/Edit";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextInput from "../../../components/inputs/textInput";
const InvoiceCart = ({
  items,
  columns,
  removeHandle,
  loadingRemove,
  comment,
  setComment,
  /*   setRemoveConfirm,ø
    removeConfirm, */
}) => {
  const navigate = useNavigate();
  const [removeConfirm, setRemoveConfirm] = useState(false);

  return (
    <Box
      sx={{
        background: (theme) =>
          items?.chLastWorkflowStepCode === "Sended"
            ? "#81b1e7"
            : items?.chLastWorkflowStepCode === "Failed"
            ? "#ef7878"
            : items?.chLastWorkflowStepCode === "Confirmed" ||
              items?.chLastWorkflowStepCode === "BuyerConfirmed" ||
              items?.chLastWorkflowStepCode === "SystemConfirmed"
            ? "#33b151"
            : items?.chLastWorkflowStepCode === "Rejected"
            ? "#b1ab33"
            : items?.chLastWorkflowStepCode === "NoNeededAction"
            ? "#48fa73"
            : items?.chLastWorkflowStepCode === "Canceled"
            ? "#ed5c8a"
            : theme.palette.mode === "dark"
            ? "#2a3042"
            : "#fff",
        borderColor: (theme) =>
          true
            ? theme.palette.mode === "dark"
              ? "#685107"
              : "#cccccc !important"
            : theme.palette.mode === "dark"
            ? "#685107"
            : "#31d231 !important",
      }}
      className="grid grid-cols-3 border border-solid rounded-lg p-3"
    >
      <div className="col-span-3 flex flex-col gap-3 md:text-base text-sm font-bold ">
        <div className="flex justify-between items-center">
          <span>
            {" "}
            {items?.chInvoiceTypeCode === "Type1" ? "اول" : "دوم"}
            {"  "} ,{"  "}
            {items?.chSaleSoftID} {"  "} ,{"  "}
            {items?.chInvoiceDate}
          </span>
          <div className="flex gap-2 relative z-50">
            <IconButton>
              <EditIcon
                onClick={() => navigate(`/sell/invoice/${items.guidRecNo}`)}
                color="warning"
              />
            </IconButton>
            <IconButton>
              <LocalPrintshopIcon
                /*        onClick={() => {
                  window.open(items.chPrintURL, "_blank");
                }} */
                onClick={() => navigate(`/sell/preview/${items.guidRecNo}`)}
                color="primary"
              />
            </IconButton>
          </div>
        </div>
        <span>
          {" "}
          {items?.chBuyerSaleSoftID}{" "}
          {items?.chBuyerSaleSoftID && items?.chBuyerName && " : "}
          {items?.chBuyerName}{" "}
        </span>
        <span className="text-xs">
          {" "}
          {items?.chLastWorkflowStepName} {items?.chTaxID}
        </span>
        <div className="w-full grid  grid-cols-2 gap-3 px-3">
          <div className="border border-solid flex flex-col justify-center items-center rounded-md py-2">
            <h3 className="text-xs text-center border-b mb-1 pb-1 font-semibold ">
              تخفیف
            </h3>
            <span className="text-sm font-bold">
              {items?.moTotalDiscount !== null
                ? items?.moTotalDiscount?.toLocaleString("en-US")
                : "-"}
            </span>
          </div>
          <div className="border border-solid flex flex-col justify-center items-center rounded-md py-2">
            <h3 className="text-xs text-center border-b mb-1 pb-1 font-semibold ">
              مالیات
            </h3>
            <span className="text-sm font-bold">
              {items?.moTotalValueAddedPrice !== null
                ? items?.moTotalValueAddedPrice?.toLocaleString("en-US")
                : "-"}
            </span>
          </div>
          <div className="border col-span-2 border-solid flex flex-col justify-center items-center rounded-md py-2">
            <h3 className="text-xs text-center border-b mb-1 pb-1 font-semibold ">
              مجموع صورتحساب
            </h3>
            <span className="text-sm font-bold">
              {items?.moTotalBillPrice !== null
                ? items?.moTotalBillPrice?.toLocaleString("en-US")
                : "-"}
            </span>
          </div>
        </div>
      </div>

      <Modal
        open={removeConfirm}
        onClose={() => {
          setRemoveConfirm(false);
          setComment("");
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { md: "90%", xs: "90%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            overflow: "auto",
            maxHeight: "95%",
            maxWidth: "400px",
          }}
        >
          <div className="py-4 px-3  mb-4 flex justify-between items-center border-b">
            <span className="text-2xl font-bold"> حذف صورتحساب </span>
            <div></div>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-xl">
              {" "}
              آیا از حذف {items?.chSaleSoftID} اطمینان دارید ؟‌
            </span>
            <TextInput
              label="توضیحات"
              rows={2}
              onChange={(e) => setComment(e)}
              value={comment}
            />
          </div>
          <div className="flex col-span-2 justify-between items-center mt-5">
            <Button
              sx={{ width: "8rem" }}
              variant="contained"
              onClick={removeHandle}
              color="error"
            >
              {loadingRemove ? (
                <>
                  <CircularProgress size={20} />
                </>
              ) : (
                <> حذف محصول</>
              )}
            </Button>
            <Button
              onClick={() => {
                setRemoveConfirm(false);
                setComment("");
              }}
              sx={{ width: "8rem", background: "#ccc" }}
              variant="contained"
              color="inherit"
            >
              انصرف
            </Button>
          </div>
        </Box>
      </Modal>
    </Box>
  );
};

export default React.memo(InvoiceCart);
